var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3583_7454)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    transform: "matrix(1 0 0 -1 0 14)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84146 7.60613V7.60525C7.79334 7.60875 7.54527 7.62363 6.99184 7.62363C6.54996 7.62363 6.2389 7.6105 6.12952 7.60525V7.60656C4.42852 7.53175 3.1589 7.23556 3.1589 6.88119C3.1589 6.52725 4.42852 6.23106 6.12952 6.15494V7.31169C6.24065 7.31956 6.55915 7.33838 6.99927 7.33838C7.52734 7.33838 7.79202 7.3165 7.84146 7.31213V6.15581C9.53896 6.2315 10.8055 6.52769 10.8055 6.88119C10.8055 7.23556 9.53896 7.53088 7.84146 7.60613ZM7.84146 6.0355V5.00038H10.2101V3.42188H3.7609V5.00038H6.12952V6.03506C4.20452 6.12344 2.75684 6.50494 2.75684 6.96169C2.75684 7.41844 4.20452 7.7995 6.12952 7.88831V11.2054H7.84146V7.88744C9.7634 7.79906 11.2076 7.418 11.2076 6.96169C11.2076 6.50538 9.7634 6.12431 7.84146 6.0355Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3583_7454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    transform: "matrix(1 0 0 -1 0 14)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.d57807ff1d439005ab90dd562febc31f.svg";
export { ForwardRef as ReactComponent };